export const editorKeys = {
  versions: (assignmentId: string) => ['versions', assignmentId],
  version: (assignmentId: string, versionId: string) => [
    'versions',
    assignmentId,
    versionId
  ]
}
